module.exports = __webpack_public_path__ + "static/media/quitdate_stage.8e6c82f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/quitdate_stage.png
// module id = 573
// module chunks = 0